import { render, staticRenderFns } from "./CatalogoDocumentos.vue?vue&type=template&id=7a91e191&scoped=true"
import script from "./CatalogoDocumentos.vue?vue&type=script&lang=js"
export * from "./CatalogoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDocumentos.vue?vue&type=style&index=0&id=7a91e191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a91e191",
  null
  
)

export default component.exports